import {
  AgreementAndPolicyCategories,
  AgreementAndPolicyTypes,
  LICENSES,
} from 'src/config/constants'
import type { IAgreementAndPolicy, ICenterBankAccount } from 'src/interfaces/center'

export const teamRatioRulesTemplate = {
  id: '',
  name: '',
  licenseType: LICENSES.daycare,
  lowAge: null,
  highAge: null,
  ratioStandard: '',
  ratioNapping: '',
  maxTeamSize: '',
}

export const agreementAndPolicyTemplate: IAgreementAndPolicy = {
  type: AgreementAndPolicyTypes.mandatory,
  category: AgreementAndPolicyCategories.registration,
  description: '',
  name: '',
  fileUrl: '',
  isCCAgreement: false,
  isPadAgreement: false,
  isSystemDefault: false,
  isArchived: false,
}

export const centerFinancialTemplate: ICenterBankAccount = {
  bankName: '',
  institutionNumber: '',
  transitNumber: '',
  accountNumber: '',
}
